import { Button, Form, Input, InputNumber, Modal } from "antd";
import type React from "react";
import { useEffect } from "react";
import { useUpdateOccurrence } from "../hooks/useEventDetail";
import type { EventOccurrence, UpdateOccurrencePayload } from "../types";

interface CapacityFormValues {
	maxAttendees: number;
	remarks?: string;
}

interface CapacityEditModalProps {
	open: boolean;
	onClose: () => void;
	occurrence?: EventOccurrence;
	primaryColor?: string;
	onSuccess?: () => void;
}

export const CapacityEditModal: React.FC<CapacityEditModalProps> = ({
	open,
	onClose,
	occurrence,
	primaryColor = "#99CA29",
	onSuccess,
}) => {
	const [form] = Form.useForm();
	const { mutate: updateOcc, isPending: isSaving } = useUpdateOccurrence();

	useEffect(() => {
		if (open && occurrence) {
			form.setFieldsValue({
				maxAttendees: occurrence.maxAttendees,
				remarks: occurrence.remarks,
			});
		} else {
			form.resetFields();
		}
	}, [open, occurrence, form]);

	const handleSubmit = (values: CapacityFormValues) => {
		if (!occurrence) return;

		const payload: UpdateOccurrencePayload = {
			maxAttendees: values.maxAttendees,
			remarks: values.remarks,
		};

		updateOcc(
			{ occurrenceId: occurrence.occurrenceId, data: payload },
			{
				onSuccess: () => {
					onSuccess?.();
				},
			},
		);
	};

	return (
		<Modal
			title="最大人数編集"
			open={open}
			onCancel={onClose}
			footer={null}
			destroyOnClose
			centered
		>
			<Form form={form} layout="vertical" onFinish={handleSubmit}>
				<Form.Item
					name="maxAttendees"
					label="定員数"
					rules={[{ required: true, message: "必須です" }]}
				>
					<InputNumber min={1} style={{ width: "100%" }} />
				</Form.Item>

				<Form.Item name="remarks" label="管理者用備考">
					<Input.TextArea rows={3} />
				</Form.Item>

				<div
					style={{
						display: "flex",
						justifyContent: "center",
						gap: 16,
						marginTop: 32,
					}}
				>
					<Button onClick={onClose} size="large">
						キャンセル
					</Button>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						loading={isSaving}
						style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
					>
						保存
					</Button>
				</div>
			</Form>
		</Modal>
	);
};
